/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../level-selection-iframe/level-selection-iframe.component.ngfactory";
import * as i2 from "../level-selection-iframe/level-selection-iframe.component";
import * as i3 from "../../../shared/oe-app.service";
import * as i4 from "../../../shared/oe-app-person.service";
import * as i5 from "../../../shared/window.service";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
import * as i7 from "./level-selection-page.component";
var styles_LevelSelectionPageComponent = ["[_nghost-%COMP%] {\n      display: block;\n      width: 100vw;\n      height: 100vh;\n    }"];
var RenderType_LevelSelectionPageComponent = i0.ɵcrt({ encapsulation: 0, styles: styles_LevelSelectionPageComponent, data: {} });
export { RenderType_LevelSelectionPageComponent as RenderType_LevelSelectionPageComponent };
export function View_LevelSelectionPageComponent_0(_l) { return i0.ɵvid(2, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "lp2-level-selection-iframe", [], null, null, null, i1.View_LevelSelectionIframeComponent_0, i1.RenderType_LevelSelectionIframeComponent)), i0.ɵdid(1, 573440, null, 0, i2.LevelSelectionIframeComponent, [i3.OeAppService, i4.OeAppPersonService, i5.WindowService, i6.NgbActiveModal, i0.ChangeDetectorRef], null, null)], null, null); }
export function View_LevelSelectionPageComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "lp2-level-selection-page", [], null, null, null, View_LevelSelectionPageComponent_0, RenderType_LevelSelectionPageComponent)), i0.ɵdid(1, 49152, null, 0, i7.LevelSelectionPageComponent, [], null, null)], null, null); }
var LevelSelectionPageComponentNgFactory = i0.ɵccf("lp2-level-selection-page", i7.LevelSelectionPageComponent, View_LevelSelectionPageComponent_Host_0, {}, {}, []);
export { LevelSelectionPageComponentNgFactory as LevelSelectionPageComponentNgFactory };
//# sourceMappingURL=level-selection-page.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/level-selection/level-selection-page/level-selection-page.component.ngfactory.js
// module id = 1755
// module chunks = 27 28 29